
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import ServicesDetail from './components/ServicesDetail';
import Projects from './components/Projects';
import ProjectsDetails from './components/ProjectsDetails';
import AboutDetails from './components/AboutDetails';
import Contact from './components/Contact';
import Footer from './components/Footer';
import ScrollToTop from './ScrollToTop';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Hero />
              <Services />
              <Projects />
            
              <Contact />
            </>
          }
        />
        <Route path="/services" element={<ServicesDetail />} />
        <Route path="/about" element={<AboutDetails />} />
        <Route path="/projects" element={<ProjectsDetails />} />
        <Route path="/projects/:category" element={<ProjectsDetails />} />
        <Route path="/contact" element={<Contact/>}/>
      </Routes>
      <Footer />
    </Router>
  );
}

export default App; 